import React from "react";
import "./CardSkill.css";

const CardSkill = ({ icon, title, description, color }) => {
  const lightenColor = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const R = Math.min(255, Math.round((num >> 16) + (255 - (num >> 16)) * (percent / 100)));
    const G = Math.min(255, Math.round(((num >> 8) & 0x00ff) + (255 - ((num >> 8) & 0x00ff)) * (percent / 100)));
    const B = Math.min(255, Math.round((num & 0x0000ff) + (255 - (num & 0x0000ff)) * (percent / 100)));
    return "#" + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
  };
  return (
    <div className="card-skill">
      <div className="card-skill__icon" style={{ backgroundColor: lightenColor(color, 90) }}>
        <span className="material-symbols-outlined" style={{ color: color }}>
          {icon}
        </span>
      </div>

      <div className="card-skill__title">
        <h4>{title}</h4>
      </div>

      <div className="card-skill__desc">
        <p>{description}</p>
      </div>
    </div>
  );
};

export default CardSkill;
